import { render, staticRenderFns } from "./PlaceMenu.vue?vue&type=template&id=aede7434&scoped=true&"
import script from "./PlaceMenu.vue?vue&type=script&lang=js&"
export * from "./PlaceMenu.vue?vue&type=script&lang=js&"
import style0 from "./PlaceMenu.vue?vue&type=style&index=0&id=aede7434&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aede7434",
  null
  
)

export default component.exports